module.exports = __webpack_public_path__ + "img/download6.d7284c98.png";